var render = function render() {
  var _vm$buttonPopUpConfig, _vm$buttonPopUpConfig2, _vm$buttonPopUpConfig3, _vm$buttonPopUpConfig4, _vm$buttonPopUpConfig5, _vm$buttonPopUpConfig6, _vm$buttonPopUpConfig7;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-modal"
  }, [((_vm$buttonPopUpConfig = _vm.buttonPopUpConfig) === null || _vm$buttonPopUpConfig === void 0 ? void 0 : _vm$buttonPopUpConfig.popUpPosition) == "bottom" ? _c("div", {
    staticClass: "bottom-page"
  }, [_c("a-tooltip", {
    attrs: {
      placement: "bottom"
    }
  }, [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(((_vm$buttonPopUpConfig2 = _vm.buttonPopUpConfig) === null || _vm$buttonPopUpConfig2 === void 0 ? void 0 : _vm$buttonPopUpConfig2.popUpTitle) || _vm.$t("提示标题")) + " ")]), _c("h2", {
    staticClass: "page-h2"
  }, [_vm._v(_vm._s(((_vm$buttonPopUpConfig3 = _vm.buttonPopUpConfig) === null || _vm$buttonPopUpConfig3 === void 0 ? void 0 : _vm$buttonPopUpConfig3.popUpTitle) || _vm.$t("提示标题")))])], 2), _c("div", {
    staticClass: "page-content"
  }, [_vm._v(_vm._s(((_vm$buttonPopUpConfig4 = _vm.buttonPopUpConfig) === null || _vm$buttonPopUpConfig4 === void 0 ? void 0 : _vm$buttonPopUpConfig4.popUpContent) || _vm.$t("弹窗内容")))]), _c("div", {
    staticClass: "page-btn"
  }, _vm._l(_vm.buttonPopUpConfig.buttonInfo, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "btn1",
      style: "color:" + item.buttonFontColor + ";background-color:" + item.buttonBgColor,
      on: {
        click: function ($event) {
          $event.stopPropagation();
          return _vm.$emit("popupClick");
        }
      }
    }, [_vm._v(" " + _vm._s((item === null || item === void 0 ? void 0 : item.buttonName) || (index == 0 ? _vm.$t("确认") : _vm.$t("取消"))) + " ")]);
  }), 0)], 1) : _c("div", {
    staticClass: "central-page"
  }, [_c("a-tooltip", {
    attrs: {
      placement: "bottom"
    }
  }, [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(((_vm$buttonPopUpConfig5 = _vm.buttonPopUpConfig) === null || _vm$buttonPopUpConfig5 === void 0 ? void 0 : _vm$buttonPopUpConfig5.popUpTitle) || _vm.$t("提示标题")) + " ")]), _c("h2", {
    staticClass: "page-h2"
  }, [_vm._v(_vm._s(((_vm$buttonPopUpConfig6 = _vm.buttonPopUpConfig) === null || _vm$buttonPopUpConfig6 === void 0 ? void 0 : _vm$buttonPopUpConfig6.popUpTitle) || _vm.$t("提示标题")))])], 2), _c("div", {
    staticClass: "page-content"
  }, [_vm._v(_vm._s(((_vm$buttonPopUpConfig7 = _vm.buttonPopUpConfig) === null || _vm$buttonPopUpConfig7 === void 0 ? void 0 : _vm$buttonPopUpConfig7.popUpContent) || _vm.$t("弹窗内容")))]), _c("div", {
    staticClass: "page-btn"
  }, _vm._l(_vm.buttonPopUpConfig.buttonInfo, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "btn1",
      style: _vm.getStyle(item),
      on: {
        click: function ($event) {
          $event.stopPropagation();
          return _vm.$emit("popupClick");
        }
      }
    }, [_vm._v(" " + _vm._s((item === null || item === void 0 ? void 0 : item.buttonName) || (index == 0 ? _vm.$t("确认") : _vm.$t("取消"))) + " ")]);
  }), 0)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };